import { render, staticRenderFns } from "./simplebiletiade.vue?vue&type=template&id=dca72188&scoped=true"
import script from "./simplebiletiade.vue?vue&type=script&lang=js"
export * from "./simplebiletiade.vue?vue&type=script&lang=js"
import style0 from "./simplebiletiade.vue?vue&type=style&index=0&id=dca72188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca72188",
  null
  
)

export default component.exports